<soft-field-ok
  fieldOkName="vertreter"
  placeholder="Vertreter"
  [title]="configuration()?.title ?? ''"
  [subtitle]="configuration()?.subtitle ?? ''"
  [parameters]="parameters()"
  [readonly]="readonly()"
  [value]="value()"
  (valueChange)="valueChange.emit($event)">
</soft-field-ok>
